import $ from 'jquery';

export function useNavDrawer() {
    const $drawer = $('#navbarSupportedContent');
    if (!$drawer.length) return;

    const $body = $('body');

    // HACK: PDF/画像プレビュー等の Bootstrap modal 開閉で孤立した modal-backdrop が body 直下に残留するケースへの保険
    // 本来は各 modal 閉鎖時に Bootstrap プラグイン側で backdrop が確実に削除されるべき
    $body.children('.modal-backdrop').remove();

    $drawer.on('show.bs.collapse', function () {
        $body.addClass('drawer-open');
    });

    $drawer.on('hide.bs.collapse', function () {
        $body.removeClass('drawer-open');
    });

    $body.on('click.navDrawer', function (e) {
        if (!$body.hasClass('drawer-open')) return;
        const $target = $(e.target);
        if ($target.closest('.navbar-collapse').length) return;
        if ($target.closest('.navbar-toggler').length) return;
        $drawer.collapse('hide');
    });
}
